module.exports = __webpack_public_path__ + "img/bannier_school_default_pic.a9e8379.jpg";